export const withResolvedError = async (requestFn, { withErrorHandler, getResolvedError }, options) => {
    try {
        const response = await withErrorHandler(requestFn, options);
        return response;
    }
    catch (error) {
        if (error instanceof Error) {
            error.__resolvedError = getResolvedError(error);
        }
        return Promise.reject(error);
    }
};
export const getErrorData = (error, getResolvedError) => {
    let resolvedError;
    if (error instanceof Error && '__resolvedError' in error) {
        resolvedError = error.__resolvedError;
    }
    return {
        ...(resolvedError ?? getResolvedError(error)),
        originalError: error,
    };
};
//# sourceMappingURL=index.js.map